import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import Icon from './index';
var customCache = new Set();
export default function createFromIconfont(scriptUrl) {
  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */
  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('data-namespace', scriptUrl);
    customCache.add(scriptUrl);
    document.body.appendChild(script);
  }

  var Iconfont = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var type = props.type,
        rest = _objectWithoutProperties(props, ["type"]);

    var content;

    if (type) {
      content = /*#__PURE__*/React.createElement("use", {
        xlinkHref: "#".concat(type)
      });
    } // fix https://github.com/ZhongAnTech/zarm/issues/835
    // @ts-ignore


    var I = Icon["default"] ? Icon["default"] : Icon;
    return /*#__PURE__*/React.createElement(I, _extends({}, rest, {
      ref: ref
    }), content);
  });
  return Iconfont;
}